

const genUUID = () => {
    let count = 0;
    return `props[${++count}]`
}


class PropArray extends Array {
    static separator = '.';

    isSpecialPath = false;

    // [SymUUID] = genUUID();

    [Symbol.toPrimitive]() {
        return 'PropArray[]';
    }

    toUnique() {
        const path = this.pathToString()
        return this._unique + (path.length > 0 ? ('_' + path) : '');
    }

    toString() {
        return this.join(PropArray.separator);
    }

    pathToString() {
        return this.join('.');
    }

    push() {
        const args = [...arguments].filter(i => typeof i !== 'symbol');
        super.push(...args)
        return this;
    }

    toArray() {
        return [...this];
    }

    clone() {
        const a = new PropArray(...this);
        a.isSpecialPath = this.isSpecialPath;
        return a;
    }

    last() {
        return this[this.length - 1];
    }

    isRoot() {
        return this.length === 0;
    }
}


export default PropArray;